import React, { useState, useRef, useEffect } from "react";

import LanguageBG from "../assets//AppLanguageBG.png"
import EngLish from "../assets/English.png";
import EnglishIcon from "../assets/Englishlangicon.png";
import Hindi from "../assets/Hindi.png";
import HindiIcon from "../assets/HindiIcon.png";
import Gujrati from "../assets/Gujrati.png";
import GujratiIcon from "../assets/GujratiIcon.png";
import Bengali from "../assets/Bengali.png";
import BengaliIcon from "../assets/BengaliIcon.png";
import Tamil from "../assets/Tamil.png";
import TamilIcon from "../assets/TamilIcon.png";
import Telegu from "../assets/Telegu.png";
import TeleguIcon from "../assets/TeleguIcon.png";
import Kannada from "../assets/Kannada.png";
import KannadaIcon from "../assets/KannadaIcon.png";
import Marathi from "../assets/Marathi.png";
import MarathiIcon from "../assets/MarathiIcon.png";
import Punjabi from "../assets/Punjabi.png";
import PunjabiIcon from "../assets/PunjabiIcon.png";
import Malayalam from "../assets/MalayalamIconlang.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import English_selected from "../assets/English_selected.png";
import Hindi_selected from "../assets/Hindi_selected.png";
import Gujarati_selected from "../assets/Gujarati_selected.png";
import Bengali_selected from "../assets/Bengali_selected.png";
import Marathi_selected from "../assets/Marathi_selected.png";
import Malayalam_selected from "../assets/MalayalamIcon.png";
import Kanada_selected from "../assets/Kannada_selected.png";
import Tamil_selected from "../assets/Tamil_selected.png";
import Telugu_selected from "../assets/Telugu_selected.png";
import Punjabi_selected from "../assets/Punjabi_selected.png";
import MarkupGrid from "./MarkupGrid";
import LoaderScreen from "./LoaderScreen";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
let resolution = window.RESOLUTION;
if (window.innerWidth >= 1920 && window.innerHeight >= 1080) {
  resolution = "FHD";
} else {
  resolution = window.innerWidth == 0 ? "FHD" : "HD"; /*resolution = "HD";*/
}
const userAgent = navigator.userAgent.toLowerCase();
if (
  userAgent.includes("webos") ||
  userAgent.includes("lg") ||
  userAgent.includes("web0s")
) {
  resolution = "FHD";
}
const AppLanguage = ({
  callback,
  shouldFocus = false,
  callback1,
  callBackToSettingPage,
}) => {
  const [state, setState] = useState({
    shouldFocusGrid: shouldFocus,
    loading: true,
    Content: [
      {
        id: "English",
        thumbnail: LanguageBG,
        title: EngLish,
        subtitle: "English",
        icon: EnglishIcon,
        selectionColor: "transparent",

        AppLanguage: "English",
      },
      {
        id: "Hindi",
        thumbnail: LanguageBG,
        title: Hindi,
        subtitle: "Hindi",
        icon: HindiIcon,
        selectionColor: "transparent",
        AppLanguage: "Hindi",
      },
      {
        id: "Gujrati",
        thumbnail: LanguageBG,
        title: Gujrati,
        subtitle: "Gujrati",
        icon: GujratiIcon,
        selectionColor: "transparent",
        AppLanguage: "Gujarati",
      },
      {
        id: "Bengali",
        thumbnail: LanguageBG,
        title: Bengali,
        subtitle: "Bengali",
        icon: BengaliIcon,
        selectionColor: "transparent",
        AppLanguage: "Bangla",
      },
      {
        id: "Tamil",
        thumbnail: LanguageBG,
        title: Tamil,
        subtitle: "Tamil",
        icon: TamilIcon,
        selectionColor: "transparent",
        AppLanguage: "Tamil",
      },
      {
        id: "Telegu",
        thumbnail: LanguageBG,
        title: Telegu,
        subtitle: "Telugu",
        icon: TeleguIcon,
        selectionColor: "transparent",
        AppLanguage: "Telugu",
      },
      {
        id: "Kannada",
        thumbnail: LanguageBG,
        title: Kannada,
        subtitle: "Kannada",
        icon: KannadaIcon,
        selectionColor: "transparent",
        AppLanguage: "Kannada",
      },
      {
        id: "Marathi",
        thumbnail: LanguageBG,
        title: Marathi,
        subtitle: "Marathi",
        icon: MarathiIcon,
        selectionColor: "transparent",
        AppLanguage: "Marathi",
      },
      {
        id: "Punjabi",
        thumbnail: LanguageBG,
        title: Punjabi,
        subtitle: "Punjabi",
        icon: PunjabiIcon,
        selectionColor: "transparent",
        AppLanguage: "Punjabi",
      },
      {
        id: "Malayalam",
        thumbnail: LanguageBG,
        title: Malayalam,
        subtitle: "Malayalam",
        icon: Malayalam_selected,
        selectionColor: "transparent",
        AppLanguage: "Malayalam",
      },
    ],
  });

  const { shouldFocusGrid, Content, loading } = state;
   const [hasSentEvent, setHasSentEvent] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      loading: false,
    }));
    if (!hasSentEvent) {
      sendTestMatomoEvent({
        eventCategory: `Page`,
        eventAction: `View`,
        eventName: `AppLanguage`,
        url: "app-langauge",
      });
       setHasSentEvent(true);
    }
  }, []);

  const handleItemSelected = (item) => {
    setSelectedItem(item);
    sendTestMatomoEvent({
      eventCategory: "AppSetting",
      eventAction: "AppLanguage",
      eventName: `LanguagePreference(${item?.AppLanguage})`,
    });
  };

  const getItemStyle = (item) => {
    return {
      ...styles.item,
      backgroundColor: item === selectedItem ? "#EC008C" : "transparent",
    };
  };

  const handleUPButton = (p) => {
    shouldFocus = false;
    setState((prevState) => ({
      ...prevState,
      shouldFocusGrid: false,
    }));
    callback1(p);
  };

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusGrid: shouldFocus,
    }));
  }, [shouldFocus]);

  const callBack = (p) => {
    if (p === "Grid") {
      setState((prevState) => ({
        ...prevState,
        shouldFocusGrid: true,
      }));
    } else if (p === "Back") {
      setState((prevState) => ({
        ...prevState,
        shouldFocusGrid: false,
      }));
      callback1("HandleUPButton");
    }
  };

  const onSelect = () => {
    callBackToSettingPage();
  };

  const SelectedLangauge = localStorage.getItem("AppLanguage");

  return (
    <div style={styles.applanguageContainer}>
      {loading && <LoaderScreen />}
      <MarkupGrid
        items={Content}
        onItemSelected={handleItemSelected}
        rowWidth="100%"
        rowHeight={244}
        columnWidth={resolution === "FHD" ? 407 : 152}
        columnHeight={resolution === "FHD" ? 224 : 194}
        itemWidth={resolution === "FHD" ? 407 : 152}
        itemHeight={resolution === "FHD" ? 224 : 194}
        numberOfColumnsEachRow={4}
        numberOfDefaultRows={3}
        selectionColor={shouldFocusGrid ? "" : "transparent"}
        selectionStyle="background"
        gapBetweenColumns={17}
        gapBetweenRows={resolution === "FHD" ? 10 : 7}
        columnBgColorOrImage="#0000"
        rowBgColorOrImage="#0000"
        shouldScrollHorizontally={false}
        shouldScrollVertically={true}
        scrollDuration={300}
        GridXCordinate={0}
        GridYCordinate={10}
        shouldFocus={shouldFocusGrid}
        callBack={callBack}
        itemComponentName="AppLanguageWidget"
        handleUPButton={handleUPButton}
        onSelect={onSelect}
        AppLanguage="AppLanguage"
        SelectedLangauge={SelectedLangauge}
      />
    </div>
  );
};

const styles = {
  applanguageContainer: {
    background: `url(${solidbackgroundimg})`,
    display: "flex",
    flexDirection: "column",
    // background: '#000000'  ,
    width: "100vw",
    height: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "center", // Center the background image
    backgroundRepeat: "no-repeat", // Do not repeat the background image
  },
};
export default AppLanguage;